import React, { FunctionComponent } from "react";
import { TOPICS, TopicKey } from "../../topics";

export interface PageHeader {
  title: string;
  deck?: string;
  /** Colours the 6px rule; ink when omitted. */
  topic?: TopicKey;
}

/** Title block for index pages (topic, tag, projects): 6px rule, display title, deck. */
export const PageHeader: FunctionComponent<PageHeader> = ({
  title,
  deck,
  topic,
  children,
}) => (
  <div className="px-gutter-sm pb-10 pt-14 md:px-gutter">
    <div
      className={`flex flex-col gap-4 border-t-[6px] pt-3.5 ${
        topic ? TOPICS[topic].borderClass : "border-ink"
      }`}
    >
      <h1 className="font-display text-display-sm font-extrabold md:text-display">
        {title}
      </h1>
      {deck && <p className="max-w-[760px] text-deck text-ink-soft">{deck}</p>}
      {children}
    </div>
  </div>
);
